import { Route } from '@angular/compiler/src/core';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Partner } from 'src/app/_models/partner';
import { MessService } from 'src/app/_services/mess-service.service';
import { PartnersService } from 'src/app/_services/partners.service';

@Component({
  selector: 'app-partners-edit',
  templateUrl: './partners-edit.component.html',
})
export class PartnersEditComponent implements OnInit, OnDestroy {
  updatePartnerForm: FormGroup;

  partnerForEdit: Partner;

  subscriptions: Subscription[] = [];

  constructor(
    private partnersService: PartnersService,
    private fb: FormBuilder,
    private messService: MessService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  // * Lifecycles === //
  ngOnInit(): void {
    this.updatePartnerForm = this.fb.group({
      code: ['', Validators.required],
      company: ['', Validators.required],
      contact: [''],
      address: [''],
      email: [''],
      phone: [''],
      note: [''],
    });

    this.subscriptions.push(
      this.partnersService.updatePartnerData.subscribe(
        (resopnseData: Partner) => {
          if (!resopnseData) {
            this.router.navigate(['./../'], { relativeTo: this.route });
            return;
          }
          this.partnerForEdit = resopnseData;
          this.patchFormForUpdate();
        }
      )
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    this.messService.clearErrors();
  }

  // * Update === //
  onUpdatePartner() {
    const partner = this.updatePartnerForm.getRawValue();
    this.subscriptions.push(
      this.partnersService
        .updatePartner(this.partnerForEdit.id, partner)
        .subscribe(
          () => {
            this.messService.add({
              severity: 'success',
              title: 'Uspešno ažuriranje',
              detail: 'Ažurirali ste partnera.',
            });
            this.router.navigate(['./../'], { relativeTo: this.route });
          },
          (error) => {
            const errorObj = error.error.errors;
            const form = this.updatePartnerForm;
            const messService = this.messService;
            Object.keys(errorObj).forEach(function (key) {
              const formControl = form.get(key);
              if (formControl) {
                // If error exist set red border to field
                formControl.setErrors({});
              }
              // Push toast error for every field
              messService.addError({
                severity: 'error',
                title: 'Greška',
                detail: errorObj[key],
                sticky: true,
              });
            });
          }
        )
    );
  }

  // * Create form === //
  private patchFormForUpdate() {
    this.updatePartnerForm.patchValue({
      code: this.partnerForEdit.code,
      company: this.partnerForEdit.company,
      company_short: this.partnerForEdit.company_short,
      contact: this.partnerForEdit.contact,
      address: this.partnerForEdit.address,
      email: this.partnerForEdit.email,
      phone: this.partnerForEdit.phone,
      note: this.partnerForEdit.note,
    });
  }
}
